import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import { Snackbar, IconButton } from "material-ui";
import { Close as CloseIcon } from "material-ui-icons";
import { clearSnackbar } from "../actions/postActionSnackbar.actions";

const styleSheet = theme => ({
    close: {
        width: theme.spacing.unit * 4,
        height: theme.spacing.unit * 4
    }
});

class PostActionSnackbar extends Component {
    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        this.props.dispatch(clearSnackbar());
    };

    render() {
        const { t, classes, message } = this.props;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                open={!!message}
                autoHideDuration={6000}
                onClose={this.handleClose}
                SnackbarContentProps={{
                    "aria-describedby": "message-id"
                }}
                message={
                    <span id="message-id">
                        {t(message)}
                    </span>
                }
                action={[
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        className={classes.close}
                        onClick={this.handleClose}>
                        <CloseIcon />
                    </IconButton>
                ]}
            />
        );
    }
}

PostActionSnackbar.propTypes = {
    classes: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    message: PropTypes.string,
    t: PropTypes.func.isRequired
};

function mapStateToProps({ postActionSnackbar: { message } }) {
    return {
        message
    };
}

export default wrapComponent(PostActionSnackbar, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/PostActionSnackbar.jsx